import { Chess } from 'chess.js';
/** Startstellung eines Spiels. */
export function initialBoard(game) {
    if (game === 'chess')
        return new Chess().fen();
    if (game === 'connect4')
        return '.'.repeat(42);
    return '.'.repeat(9); // ttt
}
/**
 * Wendet einen Zug an und liefert die neue Stellung + Status. Rein & pur —
 * dieselbe Logik nutzen Client (optimistisch) und Server (autoritativ).
 * Zugformat: Schach = "e2e4" (+ optional Umwandlungsfigur), Vier Gewinnt =
 * Spaltenindex "0".."6", Tic-Tac-Toe = Feldindex "0".."8".
 */
export function applyMove(game, board, turn, move) {
    if (game === 'chess')
        return chessMove(board, move);
    if (game === 'connect4')
        return connect4Move(board, turn, move);
    return tttMove(board, turn, move);
}
// --- Schach (chess.js) ---
function chessMove(fen, move) {
    let chess;
    try {
        chess = new Chess(fen);
    }
    catch {
        return null;
    }
    const from = move.slice(0, 2);
    const to = move.slice(2, 4);
    const promotion = move.length > 4 ? move.slice(4, 5) : undefined;
    try {
        const applied = chess.move({ from, to, ...(promotion ? { promotion } : {}) });
        if (!applied)
            return null;
    }
    catch {
        return null; // illegaler Zug
    }
    const turn = chess.turn();
    let status = 'playing';
    let winner = null;
    if (chess.isGameOver()) {
        status = 'over';
        // Die Seite am Zug ist matt -> die andere gewinnt; sonst Remis
        winner = chess.isCheckmate() ? (turn === 'w' ? 'b' : 'w') : 'draw';
    }
    return { board: chess.fen(), turn, status, winner };
}
/** 8x8-Figurenraster (row 0 = Rang 8) fuer die Anzeige. `null` = leer. */
export function chessBoard(fen) {
    try {
        return new Chess(fen).board().map((row) => row.map((c) => (c ? { type: c.type, color: c.color } : null)));
    }
    catch {
        return Array.from({ length: 8 }, () => Array.from({ length: 8 }, () => null));
    }
}
/** Legale Zielfelder einer Figur (fuer Klick-Highlights), z. B. from="e2". */
export function chessTargets(fen, from) {
    try {
        return new Chess(fen).moves({ square: from, verbose: true }).map((m) => m.to);
    }
    catch {
        return [];
    }
}
// --- Tic-Tac-Toe ---
function tttMove(board, turn, move) {
    const cell = Number(move);
    if (!Number.isInteger(cell) || cell < 0 || cell > 8 || board[cell] !== '.')
        return null;
    const next = board.slice(0, cell) + turn + board.slice(cell + 1);
    const won = tttWinner(next);
    const full = !next.includes('.');
    return {
        board: next,
        turn: turn === 'w' ? 'b' : 'w',
        status: won || full ? 'over' : 'playing',
        winner: won ?? (full ? 'draw' : null),
    };
}
export function tttWinner(board) {
    const lines = [
        [0, 1, 2], [3, 4, 5], [6, 7, 8],
        [0, 3, 6], [1, 4, 7], [2, 5, 8],
        [0, 4, 8], [2, 4, 6],
    ];
    for (const [a, b, c] of lines) {
        const v = board[a];
        if (v && v !== '.' && v === board[b] && v === board[c])
            return v;
    }
    return null;
}
// --- Vier Gewinnt (6 Zeilen x 7 Spalten, zeilenweise, row 0 = oben) ---
function connect4Move(board, turn, move) {
    const col = Number(move);
    if (!Number.isInteger(col) || col < 0 || col > 6)
        return null;
    const cells = board.split('');
    let row = -1;
    for (let r = 5; r >= 0; r -= 1) {
        if (cells[r * 7 + col] === '.') {
            row = r;
            break;
        }
    }
    if (row < 0)
        return null; // Spalte voll
    cells[row * 7 + col] = turn;
    const next = cells.join('');
    const won = connect4Winner(next);
    const full = !next.includes('.');
    return {
        board: next,
        turn: turn === 'w' ? 'b' : 'w',
        status: won || full ? 'over' : 'playing',
        winner: won ?? (full ? 'draw' : null),
    };
}
export function connect4Winner(board) {
    const at = (r, c) => (r >= 0 && r < 6 && c >= 0 && c < 7 ? board[r * 7 + c] : '.');
    const dirs = [[0, 1], [1, 0], [1, 1], [1, -1]];
    for (let r = 0; r < 6; r += 1) {
        for (let c = 0; c < 7; c += 1) {
            const p = at(r, c);
            if (p === '.')
                continue;
            for (const [dr, dc] of dirs) {
                if (at(r + dr, c + dc) === p && at(r + 2 * dr, c + 2 * dc) === p && at(r + 3 * dr, c + 3 * dc) === p) {
                    return p;
                }
            }
        }
    }
    return null;
}
//# sourceMappingURL=boardGames.js.map